import * as React from "react";
import * as R from "ramda";
import { REQUEST } from "src/co/sura/config/ajax-wrapper";
import { connect } from "react-redux";
import { DotLoader } from "react-spinners";
import { Col, Row, Glyphicon } from "react-bootstrap";
import { Form } from "react-final-form";
import NumericInput from "../../../general/componentes/NumericInput";
import DatePickerSura from "../../../general/componentes/DatePicker";
import TextoInputSelector from "../../../general/componentes/TextoInputSelector";
import { TipoEnvioAfiliacion } from "../modelo/TipoEnvioAfiliacion";
import { DatosEnvioAfiliacion } from "../modelo/EnvioAfiliacion";
import {
    enviarSATAfiliado, enviarSATMasivoAfiliados, descargarPlantillaMasivoAfiliacion, limpiarMensajesAfiliacion
} from "../modulos/procesarEmpresaActions";
import { Mensaje } from "../../../general/componentes/Mensaje";
import TextoAyuda from "../../config_general/componentes/TextoAyuda";
import { fechaAfiliacionTraslado, tipoEnvioEmpresa, poliza as textoAyudaPoliza } from "../../config_general/modelo/TextosAyuda";
import ModalAyudaVentana from "../../config_general/componentes/ModalAyudaVentana";
import { tituloVentanaCargaAfiliacion } from "../../config_general/modelo/TextoVentanaAyuda";

class EstructuraAfiliacion extends React.Component<any, any> {

    constructor(props: any) {
        super(props);

        this.renderEstadoEnvioIndividual = this.renderEstadoEnvioIndividual.bind(this);
        this.renderEstadoEnvioMasivo = this.renderEstadoEnvioMasivo.bind(this);
        this.renderPestañaEstadoCarga = this.renderPestañaEstadoCarga.bind(this);
        this.validarXLS = this.validarXLS.bind(this);

        this.state = {
            ventanaAyuda: false,
            fileUpload: React.createRef(),
            archivo: null,
            archivoCorrecto: false,
            estadoCarga: REQUEST.NONE
        };

    }

    componentWillUnmount() {
        this.props.dispatch(limpiarMensajesAfiliacion());
    }

    render() {
        const { estadoEnvioMasivo, estadoEnvioIndividual, mensajeUsuario, poliza, dni } = this.props;

        return (
            <div>
                <Row>
                    {this.crearVentanaAyuda()}
                    <Form
                        onSubmit={this.onSubmit}
                        validate={this.validate}
                        render={({ handleSubmit, invalid, errors, form, submitting, pristine, values }) => (
                            <form onSubmit={handleSubmit}>
                                <h1 className={"title"}>Envió de Empresas a SAT
                                    <button type="button" className="btns btns-glyphicon" onClick={this.actualizarModalAyuda}
                                        disabled={this.state.ventanaAyuda}>
                                        <span className="icons-table">
                                            <Glyphicon style={{ left: `10px` }} glyph="question-sign" />
                                        </span>
                                    </button>
                                </h1>
                                <div className={"card"}>
                                    <div className={"card-header"}>
                                        <h3 className={"panel-title"}>Envió individual de empresas afiliadas</h3>
                                    </div>
                                    <div className={"card-body"}>
                                        <Row className={"form-group"}>
                                            <Col sm={3}>
                                                <label htmlFor="numeroPoliza">Póliza</label>
                                                <TextoAyuda texto={textoAyudaPoliza} />
                                                <NumericInput name="numeroPoliza" />
                                            </Col>
                                            <Col sm={3}>
                                                <label htmlFor="fechaEnvio">Fecha Afiliacion - Fecha Carta</label>
                                                <TextoAyuda texto={fechaAfiliacionTraslado} />
                                                <DatePickerSura name={"fechaEnvio"} />
                                            </Col>
                                            <Col sm={2}>
                                                <label htmlFor="tipoEnvio">Tipo Envio SAT</label>
                                                <TextoAyuda texto={tipoEnvioEmpresa} />
                                                <TextoInputSelector name="tipoEnvio" maestro={this.listaProcesoEnvio()} />
                                                {errors.tipoEnvio &&
                                                    <div style={{ marginTop: '5px' }}>
                                                        <span className={"text-danger"}>{errors.tipoEnvio}</span>
                                                    </div>
                                                }
                                            </Col>
                                            <Col sm={1} style={{ marginTop: '20px' }}>
                                                <button type="button" className="btns btns-link" onClick={form.reset}
                                                    disabled={submitting || pristine}>
                                                    Limpiar
                                                </button>
                                            </Col>
                                            <Col sm={2}>
                                                <br />
                                                <button type="submit" className="btns btns-primary" disabled={submitting || invalid}>
                                                    <b>Enviar Individual</b> &nbsp;<Glyphicon className={"glyphicon-play"} glyph={"glyphicon-play"} />
                                                </button>
                                            </Col>
                                        </Row>
                                    </div>
                                </div>
                                <Row>
                                    {
                                        this.renderEstadoEnvioIndividual(estadoEnvioIndividual, mensajeUsuario, poliza, dni)
                                    }
                                </Row>
                                <br />
                                <div className={"card"}>
                                    <div className={"card-header"}>
                                        <h3 className={"panel-title"}>Envió masivo de empresas afiliadas</h3>
                                    </div>
                                    <div className={"card-body"} style={{ marginTop: '30px' }}>
                                        <Row className={"form-group"}>
                                            <Col sm={3}>
                                                <a className="btns btn-success" onClick={this.descargarPlantillaXLS} >
                                                    <b>Plantilla Excel</b> &nbsp;<Glyphicon className={"download-alt"} glyph={"download-alt"} />
                                                </a>
                                            </Col>
                                            <Col sm={3}>
                                                <a className="btns btn-primary" onClick={this.cargarArchivoXLS} >
                                                    <input type="file" ref={this.state.fileUpload} name="archivo"
                                                        accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" style={{ display: "none" }} />
                                                    <b>Cargar Excel</b> &nbsp;<Glyphicon className={"upload"} glyph={"upload"} />
                                                </a>
                                            </Col>
                                            <Col smOffset={2} sm={1}>
                                                <button type="button" className="btns btns-link" onClick={this.resetFile}
                                                    disabled={!this.state.archivoCorrecto}>
                                                    Limpiar
                                                </button>
                                            </Col>
                                            <Col sm={2}>
                                                <button className="btns btns-primary" style={{ width: '142px' }} onClick={this.enviarMasivo} disabled={!this.state.archivoCorrecto}>
                                                    <b>Enviar Masivo</b> &nbsp;<Glyphicon className={"glyphicon-play"} glyph={"glyphicon-play"} />
                                                </button>
                                            </Col>
                                        </Row>
                                    </div>
                                </div>
                                <Row>
                                    {this.renderPestañaEstadoCarga()}
                                    {this.renderEstadoEnvioMasivo(estadoEnvioMasivo, mensajeUsuario)}
                                </Row>
                            </form>
                        )}
                    />
                </Row>
            </div>
        );
    }

    renderEstadoEnvioIndividual(estado: REQUEST, mensajeUsuario: string, poliza: string, dni: string) {

        switch (estado) {
            case REQUEST.ERROR:
                return <Mensaje type={"danger"} mensaje={mensajeUsuario ? mensajeUsuario : "Se ha presentado un error, intenta nuevamente!"} />;
            case REQUEST.PENDING:
                return (
                    <div>
                        <DotLoader size={25} />
                    </div>
                );
            case REQUEST.SUCCESS:
                return (
                    <span>
                        <Mensaje type={"success"}
                            mensaje={` Se realizó la carga de la información exitosamente para la póliza: ${poliza} con dni: ${dni}. Se encuentra en proceso de envío.`}
                        />
                    </span>
                );
            default:
                return false;
        }
    }

    renderPestañaEstadoCarga() {
        switch (this.state.estadoCarga) {
            case REQUEST.ERROR:
                return <Mensaje type={"danger"} mensaje={" El archivo no se cargó porque no cumple con el formato o el tamaño de 1 Megabytes."} />;
            case REQUEST.PENDING:
                return (
                    <div>
                        <DotLoader size={25} />
                    </div>
                );
            case REQUEST.SUCCESS:
                return (
                    <span>
                        <Mensaje type={"success"} mensaje={" El archivo se cargó con exito."} />
                    </span>
                );
            default:
                return false;
        }
    }

    renderEstadoEnvioMasivo(estadoEnvioMasivo: REQUEST, mensajeUsuario: string) {
        switch (estadoEnvioMasivo) {
            case REQUEST.ERROR:
                return <Mensaje type={"danger"} mensaje={mensajeUsuario ? mensajeUsuario : "Se ha presentado un error, intenta nuevamente!"} />;
            case REQUEST.PENDING:
                return (
                    <div>
                        <DotLoader size={25} />
                    </div>
                );
            case REQUEST.SUCCESS:
                return (
                    <span>
                        <Mensaje type={"success"}
                            mensaje="Se realizó la carga de la información exitosamente esta se encuentra en proceso de envío."
                        />
                    </span>
                );
            default:
                return false;
        }
    }

    crearVentanaAyuda = () => {
        return (
            <ModalAyudaVentana
                titulo={tituloVentanaCargaAfiliacion}
                visible={this.state.ventanaAyuda}
                onCancelar={this.actualizarModalAyuda}
            >
                <p style={{ color: "#000000" }}>Por medio de esta ventana podrás enviar a SAT de forma individual o masiva las empresas nuevas o de traslado 
                de las siguientes formas:
                    <br />
                    <br />
                    <strong>Individual: </strong>Ingresando los datos de envió individual y dando clic en el botón Enviar individual.
                    <br />
                    <br />
                    <strong>Masivo: </strong>Descargar la plantilla de Excel, diligenciar los datos en esta de las afiliaciones que se enviaran y guardar los cambios, 
                    luego con el botón de cargar Excel se busca el documento con el nombre que se guardó y se selecciona, por último se da clic en el botón Enviar Masivo.
                </p>
            </ModalAyudaVentana >
        );
    }

    actualizarModalAyuda = () => {
        this.setState({ ventanaAyuda: !this.state.ventanaAyuda });
    }

    validate = (values: any) => {
        const errors = {
            numeroPoliza: undefined,
            fechaEnvio: undefined,
            tipoEnvio: undefined
        };

        if (!values.numeroPoliza)
            errors.numeroPoliza = "Por favor ingresa el numero de poliza";

        if (values.numeroPoliza && !values.fechaEnvio)
            errors.fechaEnvio = "Por favor ingrese una fecha de envio";

        if (values.numeroPoliza && values.fechaEnvio && !values.tipoEnvio)
            errors.tipoEnvio = "Por favor seleccione el tipo de proceso";

        return errors;
    };

    onSubmit = (values: any) => {
        const poliza = values.numeroPoliza ? values.numeroPoliza : undefined;
        const fechaEnvio = values.fechaEnvio ? values.fechaEnvio.format("YYYY-MM-DD").valueOf() : "";
        const tipoEnvio = values.tipoEnvio ? Number(values.tipoEnvio.value) : undefined;

        const datosEnvioAfiliacion: DatosEnvioAfiliacion = {
            poliza: poliza,
            fechaEnvio: fechaEnvio,
            tipoEnvio: tipoEnvio,
            dniUsuarioOperacion: this.props.dniUsuarioGestionLogin
        };
        this.props.dispatch(enviarSATAfiliado(datosEnvioAfiliacion));
    };

    enviarMasivo = () => {
        if (this.state.archivoCorrecto) {
            this.props.dispatch(enviarSATMasivoAfiliados(this.state.archivo));
        }
        this.resetFile();
    }

    descargarPlantillaXLS = () => {
        this.props.dispatch(descargarPlantillaMasivoAfiliacion());
    }

    resetFile = () => {
        this.setState({
            estadoCarga: REQUEST.NONE,
            archivo: null,
            archivoCorrecto: false
        });
    }

    cargarArchivoXLS = () => {
        const fileUpload = this.state.fileUpload.current;
        fileUpload.value = null;
        fileUpload.click();
        fileUpload.onchange = (e) => {
            this.validarXLS(e.target.files[0]);
        };
    }

    validarXLS(file: File) {
        if (file) {
            const nombre = file.name;
            const extencion = nombre.substring(nombre.length - 4, nombre.length);
            const tamano = file.size;
            if (extencion !== "xlsx" || tamano > 1000000) {
                this.setState({
                    estadoCarga: REQUEST.ERROR,
                    archivo: null,
                    archivoCorrecto: false
                });
                return;
            }
            this.setState({
                estadoCarga: REQUEST.SUCCESS,
                archivo: file,
                archivoCorrecto: true
            });
        }
    }

    listaProcesoEnvio = () => {
        return [].concat(
            TipoEnvioAfiliacion.map(value => ({
                value: value.codigoProceso,
                label: value.nombreProceso
            })
            ));
    }
}

export default connect((store: any) => {
    return {
        dniUsuarioGestionLogin: R.pathOr(undefined, ["inicio", "dniLogin"])(store),
        estadoEnvioIndividual: R.pathOr([], ["estructura_afiliacion", "estadoEnvioIndividual"])(store),
        estadoEnvioMasivo: R.pathOr([], ["estructura_afiliacion", "estadoEnvioMasivo"])(store),
        mensajeUsuario: R.pathOr(undefined, ["estructura_afiliacion", "mensajeUsuario"])(store),
        poliza: R.pathOr(undefined, ["estructura_afiliacion", "poliza"])(store),
        dni: R.pathOr(undefined, ["estructura_afiliacion", "dni"])(store)
    };
})(EstructuraAfiliacion);


// WEBPACK FOOTER //
// ./src/co/sura/dominio/sat/procesar_empresas/componentes/EstructuraAfiliacion.tsx